import { render, staticRenderFns } from "./SignedList.vue?vue&type=template&id=8d777bc6&"
import script from "./SignedList.vue?vue&type=script&lang=js&"
export * from "./SignedList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports